import React from 'react';
import './NavBar.css';
import NavLinks from './components/NavLinks';
import SocialNetworks from './components/SocialNetworks/SocialNetworks';
import useOpenClose from 'hooks/useOpenClose';
import MenuButton from 'modules/NavBar/components/MenuButton';
import PuppiesLabel from "modules/NavBar/components/PuppiesLabel";

export default function NavBar() {
    const { isOpen, doClose, toggle } = useOpenClose();

    return (
        <nav className={`navbar${isOpen ? ' navbar--open' : ''}`}>
            <div className={'navbar-content'}>
                <MenuButton isMenuOpen={isOpen} onClick={toggle} />
                <NavLinks doClose={doClose} />
                <PuppiesLabel/>
                <SocialNetworks />
            </div>
        </nav>
    );
}
